// extracted by mini-css-extract-plugin
export default {"tooltip":"Kp-z","sharingV2":"Lp-z","sharingIconsV2":"Mp-z","links":"Np-z","link":"Op-z","facebookV2":"Pp-z","twitterV2":"Qp-z","pinterestV2":"Rp-z"};